import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";
import Translation from "@Translation/components/Translation";
import Tip from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/Tip";
import OperatorsList from "@SearchResults/features/staticContent/components/OperatorsList";

interface TrainTipsContentProps {
    departure: string,
    destination: string,
    distanceLandMiles: string,
    operators: string[],
}

function TrainTipsContent(props: TrainTipsContentProps) {
    const {
        departure,
        destination,
        distanceLandMiles,
        operators,
    } = props

    const title = useTranslation(
        `${multiModalTranslationKey}.trains.title`,
        {departure, destination}
    )

    const description = useTranslation(
        `${multiModalTranslationKey}.trains.desc1`,
        {departure, destination, distanceLandMiles}
    )

    const {
        title: o1Title,
        desc: o1Desc,
    } = useTranslation(`${multiModalTranslationKey}.trains.trip_details.o1`)

    const {
        title: o2Title,
        desc: o2Desc,
    } = useTranslation(`${multiModalTranslationKey}.trains.trip_details.o2`)

    const {
        title: o3Title,
        desc: o3Desc,
    } = useTranslation(`${multiModalTranslationKey}.trains.trip_details.o3`)

    return (
        <>
            <TitleAndContent
                title={title}
                content={description}
            />
            <TipsPerTransportType
                subtitle={(
                    <Translation translationKey={`${multiModalTranslationKey}.trains.trip_details.title`}/>
                )}
                options={[
                    {
                        id: "train-o1",
                        option: (<Tip title={o1Title} description={o1Desc}/>),
                    },
                    {
                        id: "train-o2",
                        option: (<Tip title={o2Title} description={o2Desc}/>),
                    },
                    {
                        id: "train-o3",
                        option: (<Tip title={o3Title} description={o3Desc}/>),
                    },
                ]}
            />
            <OperatorsList
                title={(
                    <Translation
                        translationKey={`${multiModalTranslationKey}.trains.operators_list.title`}
                        translationVariables={{departure, destination}}
                    />

                )}
                operators={operators}
            />
        </>
    )
}

export default TrainTipsContent